import { z } from 'zod';
import { ResourceId, UnixTimestamp } from '../types/branded';

export const FacultyAssetDescriptorSchema = z.object({
  resourceId: ResourceId,
  fileName: z.string().min(1),
  contentType: z.string().min(1).optional(),
  sizeBytes: z.number().int().positive().optional(),
  storageKey: z.string().min(1).optional(),
  uploadedAt: UnixTimestamp.optional(),
});

export type FacultyAssetDescriptor = z.infer<typeof FacultyAssetDescriptorSchema>;
